import React from 'react';
import PropTypes from 'prop-types';
import { Thumbnail } from './Thumbnail.js';
import './StudyBrowser.styl';

function StudyBrowser(props) {
  const {
    studies,
    onThumbnailClick,
    onThumbnailDoubleClick,
    supportsDrag,
    showThumbnailProgressBar,
  } = props;

  return (
    <div className="study-browser">
      <div className="scrollable-study-thumbnails">
        {studies
          .map((study, studyIndex) =>
            study.thumbnails
              .map((thumb, thumbIndex) => {
                const {
                  active,
                  altImageText,
                  displaySetInstanceUID,
                  imageId,
                  numImageFrames,
                  ClinicalTrialTimePointID,
                  SeriesDescription,
                  SeriesNumber,
                  SeriesDate,
                  ContentDate,
                  AcquisitionDate,
                } = thumb;

                return (
                  <div
                    key={thumb.displaySetInstanceUID}
                    className="thumbnail-container"
                    data-cy="thumbnail-list"
                  >
                    <Thumbnail
                      active={active}
                      supportsDrag={supportsDrag}
                      key={`${studyIndex}_${thumbIndex}`}
                      id={`${studyIndex}_${thumbIndex}`}
                      /** study */
                      StudyInstanceUID={study.StudyInstanceUID}
                      /** thumb */
                      altImageText={altImageText}
                      imageId={imageId}
                      displaySetInstanceUID={displaySetInstanceUID}
                      numImageFrames={numImageFrames}
                      ClinicalTrialTimePointID={ClinicalTrialTimePointID}
                      SeriesDescription={SeriesDescription}
                      SeriesNumber={SeriesNumber}
                      /** define series date */
                      SeriesDate={
                        SeriesDate || ContentDate || AcquisitionDate || ''
                      }
                      /** events */
                      onClick={() => onThumbnailClick(displaySetInstanceUID)}
                      onDoubleClick={onThumbnailDoubleClick}
                      showProgressBar={showThumbnailProgressBar}
                    />
                  </div>
                );
              })
          )
          .flat()}
      </div>
    </div>
  );
}

StudyBrowser.propTypes = {
  studies: PropTypes.arrayOf(
    PropTypes.shape({
      StudyInstanceUID: PropTypes.string.isRequired,
      thumbnails: PropTypes.arrayOf(
        PropTypes.shape({
          altImageText: PropTypes.string,
          displaySetInstanceUID: PropTypes.string.isRequired,
          imageId: PropTypes.string,
          numImageFrames: PropTypes.number,
          SeriesDescription: PropTypes.string,
          SeriesNumber: PropTypes.number,
          stackPercentComplete: PropTypes.number,
        })
      ),
    })
  ).isRequired,
  supportsDrag: PropTypes.bool,
  onThumbnailClick: PropTypes.func,
  onThumbnailDoubleClick: PropTypes.func,
  showThumbnailProgressBar: PropTypes.bool,
};

StudyBrowser.defaultProps = {
  studies: [],
  supportsDrag: true,
  onThumbnailClick: () => {},
  onThumbnailDoubleClick: () => {},
  showThumbnailProgressBar: true,
};

export { StudyBrowser };
